export const colorGrey = '#A7A7A7';
export const colorLightGrey = '#DEDEDE';
export const colorLinkBlue = '#072DF8';
export const colorDarkGrey = '#383838';
export const colorGreen = '#5CDA64';
export const colorDarkGreen = '#007B08';
export const colorLuckyGrey = '#777777';
export const colorLightGreen = '#f0f8f0';
export const colorLightPink = '#fff5f5';
export const colorRed = '#f44336';
export const colorSkeletonBackground = '#E8EAEF';
export const colorInputFieldGray = '#F0F0F0';
export const colorBorderLight = '#e0e0e0';
export const colorTextDark = '#1a1a1a';
export const colorWhite = '#fff';
export const colorMediumGrey = '#666666';
export const colorLightBlueWhite = '#FCFCFF';
export const colorBlack = '#000000';
export const colorNavyBlue = '#1E3A5F';
export const colorLightBlue = '#E8EDF3';
export const colorYellow = '#FFE733';
export const colorYellowHover = '#F9D900';
export const colorDisabledBg = '#F5F5F5';
export const colorDisabledText = '#9E9E9E';
export const colorPrimaryNavy = '#24305F';
export const colorPrimaryNavyHover = '#1a2347';
